import { useCallback } from 'react';
import { NotificationsPermissionState } from './useNotificationPermissionTypes';
export const useNotificationsPermissions = (_) => {
    const activatePush = useCallback(() => Promise.resolve(NotificationsPermissionState.Enabled), []);
    return {
        activatePush,
        permissionState: NotificationsPermissionState.Enabled,
    };
};
